<script>
export default {
  name: 'Alert',
  props: {
    text: {
      type: String,
    },
  },
  methods: {
    getImg() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/${this.$chain.getName()}/ic-alert.svg`);
    },
  },
};
</script>

<template>
  <div class="upcoming-card main-block my-9">
    <v-row class="align-center justify-center">
      <v-col cols="auto"><img :src="getImg()" alt="alert icon" class="launchpad__alert-ic"></v-col>
      <v-col cols="auto"><div class="launchpad__alert">{{ text }}</div></v-col>
    </v-row>
  </div>
</template>

<style lang="scss">
.launchpad__alert {
  font-weight: 700;
  font-size: 2rem;

  &-ic {
    width: 3.5rem;
  }
}
</style>
